import request from '@/utils/request.js'
import qs from 'qs';

/***购卡申请列表 */
export function getBuyCardList(data){
    return request({
        url: 'bindPhone/buy/sim/list',
        method: 'post',
        data
    })
}

export function getChangeCardListMy(data){
    return request({
        url: 'applyChangeSim/list/my',
        method: 'post',
        data
    })
}
export function dealWithChangeCardMy(data){
    return request({
        url: 'applyChangeSim/update/my',
        method: 'post',
        data
    })
}
/****处理买卡申请****/
export function dealWithBuyCard(data){
    return request({
        url: 'bindPhone/update/buy/state',
        method: 'post',
        data
    })
}

/****换卡申请列表****/
export function getChangeCardList(data){
    return request({
        url: 'applyChangeSim/list',
        method: 'post',
        data
    })
}
/****处理换卡申请****/
export function dealWithChangeCard(data){
    return request({
        url: 'applyChangeSim/update',
        method: 'post',
        data
    })
}


/****监控停机记录****/
export function getStopRecordList(data){
    return request({
        url: 'sim/polling/stopRecord',
        method: 'post',
        data
    })
}

/** 卡片导出 */
export function exportPollingStopInfo(data){
    return request({
        url: 'export/pollingStopList',
        method: 'post',
        data
    })
}

/** 退款申请列表信息导出 */
export function exportBackMoneyApplyInfo(data){
    return request({
        url: 'export/applyRefund',
        method: 'post',
        data
    })
}


/** 流量统计--根据时间查询流量范围 */
export function flowStatistics(data){
    return request({
        url: 'flow/sim/flow/query',
        method: 'post',
        data
    })
}

/** 流量统计---根据时间查询每日流量明细 */
export function flowEveryDayDetail(data){
    return request({
        url: 'flow/sim/flow/queryEveryDayFlow',
        method: 'post',
        data
    })
}

/** 流量统计---根据时间查询每月流量明细*/
export function flowEveryMonthDetail(data){
    return request({
        url: 'flow/sim/flow/query/month/detail',
        method: 'post',
        data
    })
}


/** 流量统计---导出*/
export function flowStatisticsExport(data){
    return request({
        url: 'export/queryEveryDayFlow',
        method: 'post',
        data
    })
}
export function flowStatisticsExport1(data){
    return request({
        url: 'export/queryEveryDayFlowLimit',
        method: 'post',
        data
    })
}
export function flowStatisticsExport2(data){
    return request({
        url: 'export/queryEveryDayFlowSim',
        method: 'post',
        data
    })
}

